export default __webpack_public_path__ + "static/media/guy--mobile.f0455dce.jpg";